import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "./contexts/AuthContext";

import Portal from "./layout/Portal";

const PrivateRoute = (props) => {
  const { isAuthenticated, user } = useContext(AuthContext);
  return (
    <Route path={props.path}>
      {isAuthenticated ? (
        <Portal>{props.children}</Portal>
      ) : (
        <Redirect to="/signin" />
      )}
    </Route>
  );
};

export default PrivateRoute;
